import { useState, useEffect, type ReactNode } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

import { AppSidebar } from "@/components/app-sidebar";
import { SiteHeader } from "@/components/site-header";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";

interface AppLayoutProps {
  children: ReactNode;
  isInitialSidebarCollapsed?: boolean;
}

export function AppLayout({
  children,
  isInitialSidebarCollapsed = false,
}: AppLayoutProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const [activePage, setActivePage] = useState("");

  useEffect(() => {
    const segments = location.pathname.split("/").filter(Boolean);
    let currentPage = "/"; // Default to my-flows for root path

    if (segments.length > 0) {
      currentPage = segments[0]; // e.g., 'email', 'call-sms', 'my-flows'
    }

    setActivePage(currentPage);
  }, [location.pathname]);

  const handleNavigate = (page: string) => {
    navigate(`/${page}`);
  };

  return (
    <SidebarProvider defaultOpen={!isInitialSidebarCollapsed}>
      <div className="flex h-screen w-screen overflow-hidden">
        <AppSidebar
          user={user}
          onNavigate={handleNavigate}
          activePage={activePage}
        />
        <div className="flex flex-1 flex-col">
          {/* <SiteHeader /> */}
          <SidebarInset className="flex-1">{children}</SidebarInset>
        </div>
      </div>
    </SidebarProvider>
  );
}
